import apiService from '../ApiService';
import axiosInstance from '../axiosInstance';

const endpoint = '/application';

export const getApplication = async () => {
    try {
        const response = await apiService.getAll(endpoint);
        return response;
    } catch (error) {
        console.error('Error fetching application data:', error);
        throw error;
    }
};

export const getApplicationById = async (id) => {
    try {
        const response = await apiService.getById(endpoint, id);
        return response;
    } catch (error) {
        console.error(`Error fetching application with ID ${id}:`, error);
        throw error;
    }
};

export const createApplication = async (applicationData) => {
    try {
        const response = await apiService.create('students/pay', applicationData);
        return response;
    } catch (error) {
        console.error('Error creating application:', error);
        throw error;
    }
};

export const updateApplication = async (id, data) => {
    try {
        const response = await apiService.update(endpoint, id, data);
        return response;
    } catch (error) {
        console.error('Error upadte application:', error);
        throw error;
    }
};


export const getExport = async (filter) => {
    try {
        const response = await axiosInstance.get(`/application/export?filter=${filter}`, {
            responseType: 'blob',
        });

        const contentDisposition = response.headers['content-disposition'];
        let filename = 'applications.xlsx';

        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
            if (filenameMatch && filenameMatch[1]) {
                filename = filenameMatch[1];
            }
        }

        // Create download link
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);

        return { success: true, filename };
    } catch (error) {
        console.error('Export error:', error);
        throw error;
    }
};